<section class="content">
  <div class="hgx-page">
    <div class="hgx-page-header">
      <div>
        <h1>{{ salutation }}{{ user?.prenom ? ', ' + (user.prenom | titlecase) : '' }}</h1>
        <p class="home-date">
          @if (user?.hotel_libelle) {
          {{ user.hotel_libelle | titlecase }} ·
          }
          {{ aujourdhui | date: 'EEEE d MMMM y' : '' : 'fr' }}
        </p>
      </div>
      @if (peutVoirTableauDeBord) {
      <a class="btn btn-outline-secondary" routerLink="/dashboard/main">Tableau de bord</a>
      }
    </div>

    @if (peutVoirTableauDeBord) {
    <section class="home-kpis" aria-label="Indicateurs du jour">
      <div class="home-kpi">
        <span class="home-kpi-label">Taux d'occupation</span>
        <span class="home-kpi-value hgx-num">
          @if (indicateurs) { {{ indicateurs.taux_occupation?.value ?? 0 }} <small>%</small> } @else { — }
        </span>
      </div>
      <div class="home-kpi">
        <span class="home-kpi-label">Arrivées du jour</span>
        <span class="home-kpi-value hgx-num">
          @if (indicateurs) {
          {{ indicateurs.arrivees_jour?.value ?? 0 }}
          <small>· {{ indicateurs.arrivees_jour?.departs ?? 0 }} départ{{ (indicateurs.arrivees_jour?.departs ?? 0) > 1 ? 's' : '' }}</small>
          } @else { — }
        </span>
      </div>
      <div class="home-kpi">
        <span class="home-kpi-label">Recettes du jour</span>
        <span class="home-kpi-value hgx-num">
          @if (indicateurs) { {{ indicateurs.recettes_jour?.value | IntegerFormatPipe }} <small>FCFA</small> } @else { — }
        </span>
      </div>
      <div class="home-kpi">
        <span class="home-kpi-label">Caisses ouvertes</span>
        <span class="home-kpi-value hgx-num">
          @if (caisses) {
          {{ caisses.caisses_ouvertes ?? 0 }}
          <small>· solde {{ caisses.solde_jour | IntegerFormatPipe }} FCFA</small>
          } @else { — }
        </span>
      </div>
    </section>
    }

    <div class="home-grid" [class.home-grid--seul]="!peutVoirTableauDeBord">
      <section class="hgx-panel home-panel" aria-labelledby="titre-acces">
        <div class="home-panel-head">
          <h2 id="titre-acces">Accès rapides</h2>
        </div>
        @if (accesRapides.length) {
        <div class="home-shortcuts">
          @for (acces of accesRapides; track acces.path) {
          <a class="home-shortcut" [routerLink]="acces.path">
            <span class="home-shortcut-icon" aria-hidden="true">
              <i class="material-icons-outlined">{{ acces.icone }}</i>
            </span>
            <span class="home-shortcut-text">
              <strong>{{ acces.libelle }}</strong>
              <span>{{ acces.detail }}</span>
            </span>
          </a>
          }
        </div>
        } @else {
        <p class="home-empty">Utilisez le menu de gauche pour accéder à vos modules.</p>
        }
      </section>

      @if (peutVoirTableauDeBord) {
      <section class="hgx-panel home-panel" aria-labelledby="titre-traiter">
        <div class="home-panel-head">
          <h2 id="titre-traiter">À traiter</h2>
          @if (alertes.length) {
          <span class="hgx-badge hgx-badge--warn">{{ alertes.length }}</span>
          }
        </div>
        @if (chargement) {
        <p class="home-empty">Chargement…</p>
        } @else if (alertes.length) {
        <ul class="home-alerts">
          @for (alerte of alertes; track $index) {
          <li>
            <span class="hgx-badge hgx-badge--dot hgx-badge--{{ varianteAlerte(alerte.type) }}" aria-hidden="true"></span>
            <span>{{ alerte.message }}</span>
          </li>
          }
        </ul>
        } @else {
        <p class="home-empty">Rien à signaler pour le moment.</p>
        }
      </section>
      }
    </div>
  </div>
</section>
